<template lang="pug">
    MediaQueryProvider(:queries='mediaQueries')
        .gotmehookd-app
            component(:is="layout" :class="layoutClass")
                router-view
            modal-container
</template>

<script>
import { mapGetters } from 'vuex'
import { MediaQueryProvider } from 'vue-component-media-queries'
import SocialNotificationsStoreMixin from 'social/notifications/mixins/social-notifications-store-mixin'
import mediaQueryConfig from '../config/media-query-config'
import Cookie from 'js-cookie'
import EventBus from '../lib/event-bus'
import Events from '../lib/events'
import ModalsList from '../components/modals/modals-list'

const DEFAULT_LAYOUT = 'main'

export default {
    name: 'gotmehookd-app',

    components: {
        MediaQueryProvider,
    },

    mixins: [
        SocialNotificationsStoreMixin,
    ],

    computed: {
        ...mapGetters(['authUser']),

        layout() {
            return `${this.$route.meta.layout || DEFAULT_LAYOUT}-layout`
        },
        mediaQueries() {
            return mediaQueryConfig
        },
        layoutClass() {
            return this.$route.meta?.class
        },
    },

    watch: {
        authUser(val) {
            if (val) {
                this.fetchNotificationCounters()
            }
        },
    },

    methods: {
        async checkClickUserOrHashtag(ev) {
            const target = ev.target
            const classList = target.classList

            if (classList.contains('user-mention-link')) {
                ev.preventDefault()
                this.$router.push(target.getAttribute('href'))
            }
            else if (classList.contains('hashtag-link--creator')) {
                EventBus.$emit(Events.SEARCH_CREATOR, target.innerText)
            }
            else if (classList.contains('hashtag-link')) {
                const results = await EventBus.$$emitAsync(Events.SEARCH_POST, target.innerText)
                if (results.length == 0) {
                    this.$router.push('/')
                    this.$nextTick(() => {
                        EventBus.$emit(Events.SEARCH_POST, target.innerText)
                    })
                }
            }
        },
    },

    async created() {
        if (this.$store.getters.authCheck) {
            try {
                await this.$store.dispatch('fetchUser')
            } finally {
                if (!this.$store.getters.authCheck) {
                    this.$router.push({ name: 'login-page' })
                }
            }
        }
    },

    mounted() {
        if (!Cookie.get('gdpr_cookie') && !this.$store.getters.authCheck) {
            EventBus.$emit(Events.OPEN_MODAL, ModalsList.ACCEPT_COOKIES)
        }

        const resize = function() {
	        const vh = window.innerHeight * 0.01;
	        document.documentElement.style.setProperty('--vh', `${vh}px`);
        }

        window.addEventListener('resize', () => {
            resize();
        });

        resize();

        document.body.addEventListener('click', this.checkClickUserOrHashtag)
    }
}
</script>

<style>
body {
    padding: 0;
    margin: 0;
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
}
.gotmehookd-app {
    width: 100%;
    height: 100%;
}
</style>
